import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, normalizeStyle as _normalizeStyle, unref as _unref, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70429810"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"100%"} }
const _hoisted_2 = {
  class: "regional",
  style: {"height":"100%"}
}
const _hoisted_3 = { style: {"position":"relative","display":"flex"} }
const _hoisted_4 = {
  class: "from",
  style: {"margin":"0","width":"50%"}
}
const _hoisted_5 = {
  class: "btnBox",
  style: {"display":"block","padding":"0","width":"75px","margin-left":"40px"}
}
const _hoisted_6 = {
  class: "btnBox",
  style: {"background-color":"transparent","justify-content":"start"}
}
const _hoisted_7 = { style: {"display":"flex"} }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "operatingBtn pointer" }
const _hoisted_11 = { style: {"margin-top":"20px","display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_12 = { style: {"height":"100%","box-sizing":"border-box","position":"relative"} }
const _hoisted_13 = { class: "userFrom" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "from" }
const _hoisted_16 = { class: "from" }
const _hoisted_17 = { class: "from" }
const _hoisted_18 = { class: "from" }
const _hoisted_19 = { class: "from" }
const _hoisted_20 = { class: "btnBox" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  class: "btn line pointer"
}

import { reactive, ref, computed } from 'vue'
import { getUserTypeList,addUserType,editUserType,delUserType,getUserType } from './userApi'
import { ElMessage } from 'element-plus';

import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'userType',
  emits: ['setLine', 'delLine'],
  setup(__props, { emit: emits }) {



const { t } = useI18n();

const store = useStore();
const getLanguageValue = computed(() => store.getters.getLanguageValue);

// 查询条件
const search = reactive({
  name: '',
  pageNo: 1,
  pageSize: 10,
  total: 0
})
// 获取数据
const loading = ref(false)
const tableData = ref<[]>([])
function getList() {
  loading.value = true
  getUserTypeList(search).then(res => {
    if(res.data.records) {
      tableData.value = res.data.records
    }
    search.total = res.data.total 
  }).finally(()=>loading.value = false)
}
getList()
// 新增
const addShow = ref<any>(false)
const btnLoading = ref(false)
const formLoading = ref(false)
const form = ref<any>({})
const handleAddOpen = (type:'add'|'edit'|'details',item?:any) => {
  addShow.value = type
  if (type !== 'add') {
    formLoading.value = true
    getUserType(item.id).then(res => {
      form.value = res.data
    }).finally(()=>formLoading.value = false)
  } else {
    form.value = {
      isAdmin: 1
    }
  }
  let name = t('login.add')
  switch (type) {
    case 'add':
      name = t('login.add')
      break;
    case 'edit':
      name = t('login.edit')
      break;
    case 'details':
      name = t('login.details')
      break;
  }
  emits('setLine','add',[{ name: name, callback: function(){addShow.value = false}}])
}
// 保存
const handleSumbit = () => {
  const emailReg = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z]{2,4})+$/;
  if (!form.value.nameTc) {
    return ElMessage.error(t('login.select') + t('login.userTypeTc').toLowerCase())
  } else if (!form.value.nameSc) {
    return ElMessage.error(t('login.input') + t('login.userTypeSc').toLowerCase())
  } else if (!form.value.nameEn) {
    return ElMessage.error(t('login.input') + t('login.userTypeEn').toLowerCase())
  } else if (!form.value.type) {
    return ElMessage.error(t('login.input') + t('login.userType').toLowerCase())
  } else if (form.value.email && !emailReg.test(form.value.email)) {
    return ElMessage.error(t('login.input') + t('login.correct').toLowerCase() + t('login.userEmail').toLowerCase());
  }
  btnLoading.value = true
  if (form.value.id) {
    editUserType(form.value).then(res => {
      ElMessage.success(res.resultMessage)
      getList()
      cancel()
    }).finally(()=>btnLoading.value = false)
  } else {
    addUserType(form.value).then(res => {
      ElMessage.success(res.resultMessage)
      getList()
      cancel()
    }).finally(()=>btnLoading.value = false)
  }
}
// 刪除
const handleDel = (id: string) => {
  delUserType(id).then(res => {
    ElMessage.success(res.resultMessage)
    getList()
  })
}
// 取消
const cancel = ()=>{
  addShow.value = false;emits('delLine', 1)
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_input, {
            modelValue: search.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.name) = $event)),
            class: "w-50 m-2 inputbox",
            size: "large",
            placeholder: _ctx.$t('login.input')+_ctx.$t('login.userType'),
            type: "text",
            onKeydown: _withKeys(getList, ["enter"]),
            style: {"height":"48px"}
          }, null, 8, ["modelValue", "placeholder", "onKeydown"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "btn line pointer",
            onClick: getList
          }, _toDisplayString(_ctx.$t('login.inquire')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "btn line pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleAddOpen('add')))
        }, _toDisplayString(_ctx.$t('login.add')), 1)
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        style: {"width":"100%"},
        size: "large",
        height: "100%",
        "max-height": "calc(100% - 182px)",
        ref: "tableRef"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: _ctx.$t('login.userTypeName')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "type",
            label: _ctx.$t('login.userType')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "date",
            label: _ctx.$t('login.operating'),
            width: "250"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", {
                  class: "operatingBtn pointer",
                  onClick: ($event: any) => (handleAddOpen('details',scope.row))
                }, _toDisplayString(_ctx.$t('login.details')), 9, _hoisted_8),
                _createElementVNode("span", {
                  class: "operatingBtn pointer",
                  onClick: ($event: any) => (handleAddOpen('edit',scope.row))
                }, _toDisplayString(_ctx.$t('login.compile')), 9, _hoisted_9),
                _createVNode(_component_el_popconfirm, {
                  title: _ctx.$t('login.delete'),
                  onConfirm: ($event: any) => (handleDel(scope.row.id))
                }, {
                  reference: _withCtx(() => [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('login.delete')), 1)
                  ]),
                  _: 2
                }, 1032, ["title", "onConfirm"])
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, loading.value]
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", null, _toDisplayString(_ctx.$t('total', { total: search.total })), 1),
        _createVNode(_component_el_pagination, {
          "current-page": search.pageNo,
          "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((search.pageNo) = $event)),
          "page-size": search.pageSize,
          "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((search.pageSize) = $event)),
          background: "",
          "page-sizes": [100, 200, 300, 400],
          layout: "prev, pager, next, jumper",
          total: search.total,
          onSizeChange: getList,
          onCurrentChange: getList
        }, null, 8, ["current-page", "page-size", "total"])
      ])
    ], 512), [
      [_vShow, !addShow.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_12, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [
        (addShow.value != 'editSysTemAndRole')
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", {
                  style: _normalizeStyle({width:getLanguageValue.value==='en'?'180px':'130px'})
                }, _toDisplayString(_ctx.$t('login.userTypeTc')), 5),
                _createVNode(_component_el_input, {
                  modelValue: form.value.nameTc,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.nameTc) = $event)),
                  class: "w-50 m-2 inputbox",
                  size: "large",
                  placeholder: _ctx.$t('login.input')+_ctx.$t('login.userTypeTc'),
                  type: "text",
                  disabled: addShow.value == 'details',
                  maxlength: "100",
                  title: form.value.nameTc
                }, null, 8, ["modelValue", "placeholder", "disabled", "title"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", {
                  style: _normalizeStyle({width:getLanguageValue.value==='en'?'180px':'130px'})
                }, _toDisplayString(_ctx.$t('login.userTypeSc')), 5),
                _createVNode(_component_el_input, {
                  modelValue: form.value.nameSc,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.nameSc) = $event)),
                  class: "w-50 m-2 inputbox",
                  size: "large",
                  placeholder: _ctx.$t('login.input')+_ctx.$t('login.userTypeSc'),
                  type: "text",
                  disabled: addShow.value == 'details',
                  maxlength: "100",
                  title: form.value.nameSc
                }, null, 8, ["modelValue", "placeholder", "disabled", "title"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", {
                  style: _normalizeStyle({width:getLanguageValue.value==='en'?'180px':'130px'})
                }, _toDisplayString(_ctx.$t('login.userTypeEn')), 5),
                _createVNode(_component_el_input, {
                  modelValue: form.value.nameEn,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.nameEn) = $event)),
                  class: "w-50 m-2 inputbox",
                  size: "large",
                  placeholder: _ctx.$t('login.input')+_ctx.$t('login.userTypeEn'),
                  type: "text",
                  disabled: addShow.value == 'details',
                  maxlength: "100",
                  title: form.value.nameEn
                }, null, 8, ["modelValue", "placeholder", "disabled", "title"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", {
                  style: _normalizeStyle({width:getLanguageValue.value==='en'?'180px':'130px'})
                }, _toDisplayString(_ctx.$t('login.userType')), 5),
                _createVNode(_component_el_input, {
                  modelValue: form.value.type,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.type) = $event)),
                  class: "w-50 m-2 inputbox",
                  size: "large",
                  placeholder: _ctx.$t('login.input')+_ctx.$t('login.userType'),
                  type: "text",
                  disabled: addShow.value == 'details',
                  maxlength: "100",
                  title: form.value.type
                }, null, 8, ["modelValue", "placeholder", "disabled", "title"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("span", {
                  style: _normalizeStyle({width:getLanguageValue.value==='en'?'180px':'130px'})
                }, _toDisplayString(_ctx.$t('login.isAdmin')), 5),
                _createVNode(_component_el_select, {
                  modelValue: form.value.isAdmin,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.isAdmin) = $event)),
                  class: "w-50 m-2 inputbox",
                  placeholder: _ctx.$t('login.select')+_unref(t)('login.isAdmin'),
                  size: "large",
                  style: {"margin-top":"1px"},
                  disabled: addShow.value == 'details'
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_el_option, {
                      key: 1,
                      label: _ctx.$t('login.yes'),
                      value: 1
                    }, null, 8, ["label"])),
                    (_openBlock(), _createBlock(_component_el_option, {
                      key: 0,
                      label: _ctx.$t('login.no'),
                      value: 0
                    }, null, 8, ["label"]))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "disabled"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_loading, formLoading.value]
      ]),
      _createElementVNode("div", _hoisted_20, [
        (addShow.value != 'details')
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              (!btnLoading.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "btn line pointer",
                    onClick: handleSumbit
                  }, _toDisplayString(_ctx.$t('login.save')), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createTextVNode(_toDisplayString(_ctx.$t('login.save')) + " ", 1),
                    _createVNode(_component_el_icon, {
                      class: "el-icon is-loading",
                      style: {"margin-left":"5px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Loading)
                      ]),
                      _: 1
                    })
                  ]))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "btn pointer",
          onClick: cancel
        }, _toDisplayString(_ctx.$t('login.cancel')), 1)
      ])
    ], 512), [
      [_vShow, addShow.value]
    ])
  ]))
}
}

})